import { Pipe, PipeTransform } from '@angular/core'

/**
 * generic pipe to call functions from template
 * @hint do NOT use object literal as param inside template, as this would make it impure (and lose the performance win).
 * @example `{{ myDate | apply: myCustomDateFormatter }}`
 */
@Pipe({ name: 'apply' })
export class ApplyPipe implements PipeTransform {
  transform<T, R, TAdditionalArgs extends any[]>(
    value: T,
    fn: (arg: T, ...additionalArgs: TAdditionalArgs) => R,
    ...additionalArgs: TAdditionalArgs
  ): R {
    return fn(value, ...additionalArgs)
  }
}
